import { useMemo } from 'react';

/**
 * @param {Object} options
 * @param {'left'|'center'|'right'} options.textAlign
 * @param {{width: number, margin: {left: number, right: number}}} options.shape
 * @returns {{x: number, textAnchor: 'start'|'middle'|'end'}}
 */
const useTextProps = ({ textAlign, shape }) => {
  const textProps = useMemo(
    /** @returns {{x: number, textAnchor: 'start'|'middle'|'end'}} */ () => {
      if (textAlign === 'right') {
        return {
          x: shape.width - shape.margin.right,
          textAnchor: 'end',
        };
      }
      if (textAlign === 'left') {
        return {
          x: shape.margin.left,
          textAnchor: 'start',
        };
      }
      return {
        x: shape.margin.left + Math.max(0, shape.width - shape.margin.left - shape.margin.right) / 2,
        textAnchor: 'middle',
      };
    },
    [shape.margin, shape.width, textAlign],
  );
  return textProps;
};

export default useTextProps;
